"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AdminDashboard = _interopRequireDefault(require("@/views/dashboard/AdminDashboard"));

var _AgentDashboard = _interopRequireDefault(require("@/views/dashboard/AgentDashboard"));

var _MerchantDashboard = _interopRequireDefault(require("@/views/dashboard/MerchantDashboard"));

//
//
//
//
//
//
var _default = {
  name: 'Dashboard',
  components: {
    AdminDashboard: _AdminDashboard.default,
    AgentDashboard: _AgentDashboard.default,
    MerchantDashboard: _MerchantDashboard.default
  },
  computed: {
    mode: function mode() {
      var mode = this.$store.getters.mode;
      var capitalized = mode.charAt(0).toUpperCase() + mode.slice(1);
      return "".concat(capitalized, "Dashboard");
    }
  }
};
exports.default = _default;